import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/logo-pdf.png'


const _hoisted_1 = { class: "view-container confirmation-view" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "heading-title" }, "Confirmation")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "verbiage-header" }, " Please carefully review and confirm your demographic information and enrollment elections below. If you wish to make any changes, click “Modify.” To continue, please read the terms and conditions at the bottom of the page and click “Submit.” ")
], -1)
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "my-table-section" }
const _hoisted_7 = {
  class: "form-check-label confirm-review",
  for: "confirmReview"
}
const _hoisted_8 = { class: "review-text" }
const _hoisted_9 = {
  id: "pdfContentContainer",
  style: {"display":"none"}
}
const _hoisted_10 = { id: "pdfContent" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "pdf-logo"
}, null, -1)
const _hoisted_12 = {
  class: "heading-title-for-print",
  id: "print-title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationTable = _resolveComponent("ConfirmationTable")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_ConfirmationSave = _resolveComponent("ConfirmationSave")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("form", _hoisted_4, [
        (_ctx.validationMsg)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "alert alert-danger",
              innerHTML: _ctx.validationMsg
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true),
        _createVNode(_component_ConfirmationTable, {
          "profile-data": _ctx.profileData,
          "qualifying-beneficiary-data": _ctx.qualifyingBeneficiaryData,
          "get-state-name": _ctx.getStateName,
          "get-country-name": _ctx.getCountryName,
          "dependent-data": _ctx.dependentData,
          "benefits-data": _ctx.benefitsData,
          "monthly-premium-data": _ctx.monthlyPremiumData,
          "get-monthly-country-name": _ctx.getMonthlyCountryName,
          "get-monthly-state-name": _ctx.getMonthlyStateName,
          "amount-today-data": _ctx.amountTodayData,
          "documents-data": _ctx.documentsData,
          "gender-options": _ctx.genderOptions,
          countries: _ctx.countries,
          "payment-methods": _ctx.paymentMethods,
          "account-types": _ctx.accountTypes,
          "is-stripe-enabled": _ctx.isStripeEnabled,
          "is-payment-enabled": _ctx.isPaymentEnabled,
          "enrollment-type": _ctx.enrollmentType,
          "open-enrollment-unbundled-benefits": _ctx.openEnrollmentUnbundledBenefits,
          "open-enrollment-bundles": _ctx.openEnrollmentBundles,
          "card-detail": _ctx.cardDetail
        }, null, 8, ["profile-data", "qualifying-beneficiary-data", "get-state-name", "get-country-name", "dependent-data", "benefits-data", "monthly-premium-data", "get-monthly-country-name", "get-monthly-state-name", "amount-today-data", "documents-data", "gender-options", "countries", "payment-methods", "account-types", "is-stripe-enabled", "is-payment-enabled", "enrollment-type", "open-enrollment-unbundled-benefits", "open-enrollment-bundles", "card-detail"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              class: "form-check-input",
              id: "confirmReview",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reviewChecked) = $event)),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeReview && _ctx.changeReview(...args)))
            }, null, 544), [
              [_vModelCheckbox, _ctx.reviewChecked]
            ]),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.enrollmentType == 0
                ? "I have reviewed the details provided above and confirm they are accurate and true. Furthermore, I have reviewed the details provided in the Qualifying Event Notice I received by mail. By clicking NEXT, I agree to elect COBRA coverage."
                : 'I have reviewed the details provided above and confirm they are accurate and true. By clicking "Submit", I agree to elect the benefits above.'), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("h1", _hoisted_12, " Your confirmation number is " + _toDisplayString(_ctx.profileData.electionId), 1),
          _createVNode(_component_ConfirmationTable, {
            "profile-data": _ctx.profileData,
            "qualifying-beneficiary-data": _ctx.qualifyingBeneficiaryData,
            "get-state-name": _ctx.getStateName,
            "get-country-name": _ctx.getCountryName,
            "dependent-data": _ctx.dependentData,
            "benefits-data": _ctx.benefitsData,
            "monthly-premium-data": _ctx.monthlyPremiumData,
            "get-monthly-country-name": _ctx.getMonthlyCountryName,
            "get-monthly-state-name": _ctx.getMonthlyStateName,
            "amount-today-data": _ctx.amountTodayData,
            "documents-data": _ctx.documentsData,
            "modify-btn": false,
            "gender-options": _ctx.genderOptions,
            countries: _ctx.countries,
            "payment-methods": _ctx.paymentMethods,
            "account-types": _ctx.accountTypes,
            "enrollment-type": _ctx.enrollmentType,
            "open-enrollment-unbundled-benefits": _ctx.openEnrollmentUnbundledBenefits,
            "open-enrollment-bundles": _ctx.openEnrollmentBundles,
            "card-detail": _ctx.cardDetail
          }, null, 8, ["profile-data", "qualifying-beneficiary-data", "get-state-name", "get-country-name", "dependent-data", "benefits-data", "monthly-premium-data", "get-monthly-country-name", "get-monthly-state-name", "amount-today-data", "documents-data", "gender-options", "countries", "payment-methods", "account-types", "enrollment-type", "open-enrollment-unbundled-benefits", "open-enrollment-bundles", "card-detail"])
        ])
      ])
    ]),
    _createVNode(_component_AppFooter, {
      "save-btn-txt": _ctx.allBenefitsWaived || _ctx.enrollmentType == 1 ? 'SUBMIT' : 'NEXT',
      "tool-tip": "Please accept the acknowledgment by checking the checkbox in the legal details card to be able to continue.",
      onSubmitHandler: _ctx.submitHandler,
      onBackButtonHanlder: _ctx.backButtonHanlder,
      "is-form-invalid": !_ctx.reviewChecked
    }, null, 8, ["save-btn-txt", "onSubmitHandler", "onBackButtonHanlder", "is-form-invalid"]),
    _createVNode(_component_ConfirmationSave, {
      visible: _ctx.showConfirmationModal,
      onClose: _ctx.closeConfirmationModal,
      onConfirmEnrollment: _ctx.confirmEnrollment
    }, null, 8, ["visible", "onClose", "onConfirmEnrollment"])
  ], 64))
}